<header [hidden]="tenantService.isTenantPAK()" class="mb-5">
    <nav class="navbar nav-bar-height pl-3">
        <div class="d-flex container align-items-center ">
            <a class="b-0" href=""><img alt="PZU" src="assets/images/pzu-logo.svg" class="pzu-logo"></a>
            <span class="page-header pl-4">Zgłoszenie sprawy</span>
        </div>
    </nav>
</header>

<shared-selfservice-pak-extensions *ngIf="tenantService.isTenantPAK()"></shared-selfservice-pak-extensions>
<router-outlet></router-outlet>
<ng-template appCookieDlg></ng-template>

